import SectionHeading from "./SectionHeading";
import { endorses, stats } from "@/mocks/chiGuaData";

const principles = [
  {
    icon: "ri-file-list-3-line",
    title: "只做并排，不做判决",
    body: "我们的核心动作是把「台前口径」和「实况物料」放到同一张纸上。结论交给读者，不代替任何人盖章定性。",
  },
  {
    icon: "ri-focus-2-line",
    title: "物料必须可查证",
    body: "采访、节目、通稿、公开影像才进档案。捕风捉影、私生活猜测、未证实的匿名爆料，一律不收。",
  },
  {
    icon: "ri-refresh-line",
    title: "认错与下线同样重要",
    body: "当事方对条目提出异议并经核实后，我们会第一时间修正或整条下线，也在口播里大大方方承认反转。",
  },
  {
    icon: "ri-empathize-line",
    title: "围观有度，攻击有界",
    body: "热度归热度，是非归是非。我们拒绝煽动网络暴力，鼓励清醒围观，把情绪留给作品本身。",
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <SectionHeading
              index="05"
              en="About us"
              title="吃瓜反差，是一间怎么样的「档案馆」？"
            />
            <div className="mt-6 space-y-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              <p>
                吃瓜反差把自己定位为<b className="text-foreground-950">人设翻车的公共对照表</b>
                。娱乐内容越刷越快、记忆越删越干净，我们想做的，是把那些
                「曾经说过的」和「后来做的」并排保存下来，让塌房不只是一串零散热搜。
              </p>
              <p>
                我们不发通稿式通稿，也不做情绪化的「锤人」。编辑部的日常是检索公开物料、整理时间线、复核来源，
                然后交给读者按热度、按栏目自行翻阅——<b className="text-primary-700">崩得碎不碎，摆开看最清楚</b>。
              </p>
              <p>
                内容覆盖塌房瞬间、人设崩塌、滤镜破碎、偶像失格与人设翻车等常见类型，按热度持续滚动。
                我们相信，理性围观本身就是一种内容能力。
              </p>
            </div>

            <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-xl border border-background-200/70 bg-background-50 p-4 text-center"
                >
                  <p className="font-heading text-2xl font-black text-primary-600 md:text-3xl">
                    {s.value}
                  </p>
                  <p className="mt-1 text-xs font-medium text-foreground-500">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {principles.map((p) => (
                <div
                  key={p.title}
                  className="rounded-xl border border-background-200/70 bg-background-50 p-5"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-100 text-secondary-900">
                    <i className={`${p.icon} text-lg`} />
                  </span>
                  <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
                    {p.title}
                  </h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{p.body}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 用户口碑 */}
        <div className="mt-14">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
            <h3 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              大家怎么围观我们
            </h3>
            <span className="flex items-center gap-1 text-sm font-semibold text-accent-600">
              <i className="ri-star-fill" />
              4.9 · 站内口碑
            </span>
          </div>
          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
            {endorses.map((e) => (
              <figure
                key={e.name}
                className="flex flex-col rounded-2xl border border-background-200/70 bg-background-50 p-5"
              >
                <div className="flex items-center gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm" />
                  ))}
                </div>
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-800">
                  「{e.quote}」
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 font-heading text-sm font-bold text-background-50">
                    {e.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-900">{e.name}</span>
                    <span className="block text-xs text-foreground-500">{e.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}